/* eslint-disable react-hooks/rules-of-hooks */
import React, { useEffect, useState } from 'react'
import { BulletList } from 'react-content-loader'

import '../../ShopList/list.scss'

import { useNavigate } from 'react-router-dom'

export default function index(data) {
  const [users, setUsers] = useState([])
  const navigate = useNavigate()

  useEffect(() => {
    setUsers(data.data)
  }, [data])

  return (
    <>
      <table className='table'>
        <thead>
          <tr>
            <th>نام </th>
            <th>شماره موبایل</th>
            <th>ایمیل</th>
            <th>وضعیت</th>
            <th>عملیات</th>
          </tr>
        </thead>
        <tbody>
          {users ? users.map(item => (
              <tr key={item._id}>
                <td>{item.name}</td>
                <td>{item.phoneNumber}</td>
                <td>{item.email ? item.email : '-'}</td>
                <td>{item.status === true ? 'فعال' : 'غیرفعال'}</td>
                <td>
                  <button onClick={() => navigate(`/cc/users/detail/${item._id}`)}>ویرایش</button>
                </td>
              </tr>
            )) : <tr><td colSpan="5"><BulletList rtl style={{ width: '30%', rowspan: '5' }}/></td></tr>}
        </tbody>
      </table>
    </>
  );
}
